module.exports = __webpack_public_path__ + "img/5.e3156fdc.webp";